import { useEffect, useRef } from 'react';

/**
 * A custom React hook that determines if the component is on its first render.
 *
 * @returns {boolean} Returns true if it's the component's first render, false otherwise.
 *
 * @example
 * function MyComponent() {
 *   const isFirstRender = useFirstRender();
 *
 *   if (isFirstRender) {
 *     console.log('This is the first render');
 *   }
 *
 *   return <div>My Component</div>;
 * }
 */
function useFirstRender() {
  const firstRender = useRef(true);

  useEffect(() => {
    firstRender.current = false;
  }, []);

  return firstRender.current;
}

export { useFirstRender };
